"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIVERSAL = exports.ATTRIBUTE = exports.CLASS = exports.COMBINATOR = exports.COMMENT = exports.ID = exports.NESTING = exports.PSEUDO = exports.ROOT = exports.SELECTOR = exports.STRING = exports.TAG = void 0;
exports.TAG = "tag";
exports.STRING = "string";
exports.SELECTOR = "selector";
exports.ROOT = "root";
exports.PSEUDO = "pseudo";
exports.NESTING = "nesting";
exports.ID = "id";
exports.COMMENT = "comment";
exports.COMBINATOR = "combinator";
exports.CLASS = "class";
exports.ATTRIBUTE = "attribute";
exports.UNIVERSAL = "universal";
//# sourceMappingURL=types.js.map